/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { Stat } from 'walden-fast/types/stats';

export interface StatListSignature {
  Args: {
    isDisabled?: boolean;
    stats?: Stat[];
  };
  Element: HTMLElement;
}

const StatListComponent = templateOnlyComponent<StatListSignature>();
export default StatListComponent;
